// @ts-ignore
import Image from "next/image";
import { CSSProperties, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./modal2.component.module.scss";

export interface ModalProps {
  onClose: () => void;
}

interface ComponentModalProps extends ModalProps {
  children: any;
  overlayStyle?: CSSProperties;
  modalStyle?: CSSProperties;
  bodyStyle?: CSSProperties;
  hasCloseBtn?: boolean;
}

function Modal2({
  children,
  onClose,
  overlayStyle,
  modalStyle,
  bodyStyle,
  hasCloseBtn = true
}: ComponentModalProps) {
  const [isBrowser, setIsBrowser] = useState(false);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  const modalContent = (
    <div
      style={overlayStyle}
      className={styles.overlay}
      onClick={() => onClose()}
    >
      <div
        style={modalStyle}
        className={styles.modal}
        onClick={e => e.stopPropagation()}
      >
        <div className={styles.bg}></div>
        {hasCloseBtn && (
          <div className={styles.close} onClick={onClose}>
            <Image
              src="/images/cancel.png"
              width={128}
              height={128}
              alt="close"
            />
          </div>
        )}
        <div style={bodyStyle} className={styles.body}>
          {children}
        </div>
      </div>
    </div>
  );

  if (isBrowser) {
    return createPortal(
      modalContent,
      document.getElementById("modal-root") as Element
    );
  } else {
    return null;
  }
}

export default Modal2;
